<template>
  <div class="content-navbar">
    <nav class="verbal-identity-nav" ref="nav">
      <router-link
        v-for="link in links"
        :key="link.name"
        :to="{ name: link.name }"
        class="nav-link"
        exact-active-class="active-link"
      >
        {{ link.label }}

      </router-link>

      <div class="nav-underline" :style="underlineStyle"></div>
    </nav>

    <router-view />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

interface NavLink {
  name: string
  label: string
}

@Component
export default class NavInternal extends Vue {

  @Prop({
    type: Array,
    required: true,
    default: () => []
  })
  readonly links!: NavLink[]

  underlineStyle: Record<string, string> = {
    width: '0px',
    transform: 'translateX(0px)'
  }

  mounted() {
    this.$nextTick(() => {
      this.moveUnderline()
      window.addEventListener('resize', this.moveUnderline)
    })
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.moveUnderline)
  }

  @Watch('$route')
  onRouteChange() {
    this.$nextTick(() => {
      this.moveUnderline()
    })
  }

  moveUnderline() {
    const nav = this.$refs.nav as HTMLElement
    if (!nav) return

    const active = nav.querySelector('.active-link') as HTMLElement
    if (!active) return

    const navRect = nav.getBoundingClientRect()
    const activeRect = active.getBoundingClientRect()

    this.underlineStyle = {
      width: `${activeRect.width}px`,
      transform: `translateX(${activeRect.left - navRect.left}px)`
    }
  }
}
</script>

<style lang="scss">
.verbal-identity-nav {
  position: relative;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  min-width: 1032px;
  max-width: 1032px;
  width: 100%;
  margin: 60px 0;
}

.nav-link {
  text-decoration: none;
  color: #999;
  padding: 10px;
  font-size: 18px;
  font-weight: 600;
  transition: color 0.2s ease;
}

.nav-link:hover {
  color: #000;
}

.nav-link.active-link {
  color: #000;
}

.nav-underline {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  background: #000;
  transition:
    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform, width;
}
</style>
